<template>
  <component :is="dynamicSvg" v-if="dynamicSvg" :style="iconStyle" ref="svgRef" />
</template>

<script setup lang="ts">
import { ref, watch, onBeforeMount, computed } from 'vue'

interface ComponentPublicInstance<T> {
  $el: T
}

const { size = '20', ...props } = defineProps<{
  icon: string
  size?: string
}>()
const emit = defineEmits<{
  iconReady: []
}>()

const dynamicSvg = ref<string | null>(null)
const svgRef = ref<ComponentPublicInstance<HTMLElement> | null>(null)

const importSvg = async (svgName: string) => {
  if (svgName) {
    return await import(`@/assets/icons/${svgName}.svg`)
  }
}

const iconStyle = computed(() => ({
  width: size ? `${size}px` : '100%',
  height: size ? `${size}px` : '100%',
}))

watch(
  () => props.icon,
  async svg => (dynamicSvg.value = await importSvg(svg)),
)

watch(
  () => svgRef.value?.$el,
  () => {
    emit('iconReady')
  },
)

onBeforeMount(async () => {
  dynamicSvg.value = await importSvg(props.icon)
})
</script>

<style scoped lang="scss">
svg {
  display: block;
}
:deep(*) {
  stroke: currentColor;
}
</style>
